import { render, staticRenderFns } from "./FinancialItemPremiumsModal.vue?vue&type=template&id=62dd8ae5&scoped=true"
import script from "./FinancialItemPremiumsModal.vue?vue&type=script&lang=js"
export * from "./FinancialItemPremiumsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dd8ae5",
  null
  
)

export default component.exports